module.exports = __webpack_public_path__ + "images/oth-pricing-banner-mobile-bg.jpg";